import React from "react";

const ProductionIcon = React.forwardRef(
  (
    {
      size = 44,
      bgColor = "#5062F0",
      dotColor = "#FFFFFF",
      dotStrokeColor = "#010311",
      dotStrokeWidth = 0.5,
      dotRadius = 2.5,   
      rx = 8,
      withBg = true,
      className,
      ...props
    },
    ref
  ) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {withBg && <rect width="44" height="44" rx={rx} fill={bgColor} />}

      <circle
        cx="15.75"
        cy="22"
        r={dotRadius}
        fill={dotColor}
        stroke={dotStrokeColor}
        strokeWidth={dotStrokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      <circle
        cx="22"
        cy="22"
        r={dotRadius}
        fill={dotColor}
        stroke={dotStrokeColor}
        strokeWidth={dotStrokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      <circle
        cx="28.25"
        cy="22"
        r={dotRadius}
        fill={dotColor}
        stroke={dotStrokeColor}
        strokeWidth={dotStrokeWidth}
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  )
);

export default React.memo(ProductionIcon);
